import React from 'react';
import { Modal, Box, IconButton, Typography, Button, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// interface ModalFormsProps {
// 	show: boolean;
// 	handleClose: () => void;
// 	modalHeader: string;
// 	modalBody: React.ReactNode;
// 	modalFooter?: React.ReactNode;
// 	modalId?: string;
// 	modalClass?: string;
// 	size?: 'sm' | 'md' | 'lg'; // Small, Medium, or Large size
// 	backdrop?: boolean;
//   }

const ModalForms = ({
  show,
  handleClose,
  modalHeader,
  modalBody,
  modalFooter = '',
  modalId,
  modalClass,
  size = 'lg',
  backdrop = true,
}) => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // const getWidth = () => {
  //   // only mobile responsive
  //   if (isMobile) return '95%';

  //   return size === 'lg' ? '80%' : size === 'sm' ? '80%' : '50%';
  // };

  return (
    <Modal
      open={show}
      onClose={handleClose}
      aria-labelledby={modalId}
      aria-describedby="modal-description"
      closeAfterTransition
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: size === 'lg' ? '80%' : size === 'sm' ? '80%' : '50%',
          // width: { getWidth },
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          outline: 'none',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
        className={modalClass}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            {modalHeader || 'Modal Title'}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ mt: 1 }}>{modalBody}</Box>

        {modalFooter && <div style={{ marginTop: '20px' }}>{modalFooter}</div>}
      </Box>
    </Modal>
  );
};

export default ModalForms;

// import React from 'react';
// import { Modal } from 'react-bootstrap';

// const ModalForms = ({ show, handleClose, modalHeader, modalBody, modalFooter = '', modalId, modalClass, size = 'lg', backdrop = true }) => {
// 	return (
// 		<Modal show={show} onHide={handleClose} className={'theme-modal'} id={''} size={size} centered={true} backdrop={backdrop}>
// 			<Modal.Header closeButton>
// 				<Modal.Title>{modalHeader}</Modal.Title>
// 			</Modal.Header>
// 			<Modal.Body>
// 				<div>{modalBody}</div>
// 			</Modal.Body>
// 			{modalFooter &&
// 				<Modal.Footer>
// 					{modalFooter}
// 				</Modal.Footer>
// 			}
// 		</Modal>
// 	);
// }

// export default ModalForms;
